<template>
<div :class="{ 'form-group': formGroupVisible }">
	<div
		class="d-flex justify-content-between align-items-center mb-2"
		v-if="labelVisible">
		<label class="font-weight-bold mb-0">{{ $t(label) }}</label>
	</div>
	<div
		class="d-flex justify-content-between align-items-center mb-2"
		v-if="wareHouseInventoryModals">
		<label class="font-weight-bold mb-0">{{ $t(label) }}</label>
	</div>
	<multiselect
		:placeholder="$t('Select Warehouse')"
		class="orders-status-list multiselect-auto-width form-control mr-3"
		label="label"
		track-by="_id"
		:options="options"
		:show-labels="false"
		:allow-empty="false"
		:loading="isFetching"
		:disabled="options.length === 0"
		@select="onChange">
		<template slot="option" slot-scope="props">
			<div class="option__desc d-flex flex-column">
				<span class="option__label">
					{{ props.option.label }}
				</span>
				<span
					class="option__address mt-1"
					v-if="!simpleDescription"
					v-tooltip="props.option.address.length > 25 ? props.option.address : ''">
					{{ getAddressLabel(props) }}
					<span
						class="ml-1"
						v-if="props.option.subdistrict && props.option.subdistrict !== null">
						{{ props.option.subdistrict.name }}
					</span>
					<span
						class="mx-1"
						v-if="props.option.city && props.option.city !== null">
						{{ props.option.city.name }},
					</span>
					<span v-if="props.option.province && props.option.province !== null">
						{{ props.option.province.name }}
					</span>
				</span>
				<span
					class="option__address mt-1"
					v-if="simpleDescription">
					<span
						class="mr-1"
						v-if="props.option.city && props.option.city !== null">
						{{ props.option.city.name }},
					</span>
					<span v-if="props.option.province && props.option.province !== null">
						{{ props.option.province.name }}
					</span>
				</span>
			</div>
		</template>
	</multiselect>
	<div class="modals">
		<!-- Add Warehouse -->
		<warehouse-form
			:show="isWarehouseFormVisible"
			@set="setWarehouse"
			@close="isWarehouseFormVisible = false"
		/>
	</div>
</div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import warehouseApi from '@/api/warehouse';
import { getAxiosErrorMessage, duplicateVar } from '@/lib/helper';
import WarehouseForm from '@/components/WarehouseForm.vue';
import productInventoryApi from '@/api/product-inventory';

export default {
	name: 'WarehouseSelect',
	props: {
		// product: {
		// 	type: Object,
		// },
		label: {
			type: String,
			default: 'Warehouse',
		},
		warehouse: {
		},
		disabledOptions: {
			type: Array,
			default: () => [],
		},
		labelVisible: {
			type: Boolean,
			default: true,
		},
		formGroupVisible: {
			type: Boolean,
			default: true,
		},
		simpleDescription: {
			type: Boolean,
			default: false,
		},
		selectedId: {
			type: String,
			default: null,
		},
		warehouseInventory: {
			type: Boolean,
			default: false,
		},
		hiddenButtonAdd: {
			type: Boolean,
			default: () => false,
		},
		wareHouseInventoryModals: {
			type: Boolean,
			default: () => false,
		},
		savedProductId: {
			type: String,
			default: '',
		},
	},
	components: {
		WarehouseForm,
	},
	data() {
		return {
			// warehouses: [],
			selected: null,
			isFetching: false,
			isWarehouseFormVisible: false,
			productInventory: [],
		};
	},
	computed: {
		...mapGetters({
			warehouses: 'productWarehouse/warehouse',
			selectOptions: 'productWarehouse/options',
		}),
		warehouseSettingLink() {
			const baseUrl = window.location.origin;
			const link = `${baseUrl}/settings/store#warehouse`;
			return link;
		},
		productId() {
			return this.savedProductId;
		},
		options() {
			let options = duplicateVar(this.selectOptions);

			if (this.warehouseInventory) {
				const no = {
					_id: 'no',
					label: 'No Warehouse',
				};
				const all = {
					_id: 'all',
					label: 'All Warehouse',
				};
				options.unshift(no, all);
			}
			if (this.warehouses?.length > 0) {
				const filter = option => this.warehouses?.findIndex(curr => curr.warehouse_id === option._id) === -1;
				options = options?.filter(filter);
			}
			return options;
		},
		hiddenAddButton() {
			return !this.hiddenButtonAdd;
		},
	},
	mounted() {
		this.initBus();
	},
	methods: {
		...mapActions({
			setInventory: 'productWarehouse/setWarehouse',
			setOptions: 'productWarehouse/setOptions',
			appendOptions: 'productWarehouse/appendOptions',
			addWarehouse: 'productWarehouse/addWarehouse',
		}),
		init() {
			this.fetchProductInventory();
			this.fetchWarehouse();
		},
		initBus() {
			this.$bus.$on('set-warehouse', this.setWarehouse);
		},
		fetchWarehouse() {
			this.isFetching = true;
			const params = {
				page: 1,
				limit: 100,
				is_deleted: false,
			};
			const callback = (response) => {
				const warehouses = response.data;
				this.$emit('fetched', warehouses);
				// this.warehouses = warehouses;
				this.setOptions(warehouses);
				this.isFetching = false;
			};
			const errorCallback = (e) => {
				const message = getAxiosErrorMessage(e);
				this.$notify({
					group: 'app',
					type: 'error',
					title: 'Warehouses',
					text: message,
				});
				this.isFetching = false;
			};
			warehouseApi.getWarehouses(params, callback, errorCallback);
		},
		fetchProductInventory() {
			if (this.productId !== null) {
				const params = {
					product_id: this.productId,
				};
				const callback = (response) => {
					const inventories = response.data;
					this.productInventory = inventories;
					this.setInventory(inventories);
					// this.isMultiWarehouseFetched = true;
				};
				const errorCallback = (e) => {
					console.log(e);
				};
				productInventoryApi.getList(params, callback, errorCallback);
			}
		},
		getAddressLabel(props) {
			return props.option.address.length > 25 ? `${props.option.address.substr(0, 25)}... ` : props.option.address;
		},
		onChange(value) {
			value = {
				...value,
				warehouse_id: value._id,
				warehouse_label: value.label,
			};
			this.selected = null;
			this.$emit('input', value);
		},
		setWarehouse(warehouse) {
			this.appendOptions(warehouse);
			// this.warehouses.push(warehouse);
		},
	},
	created() {
		this.init();
	},
	watch: {
		// warehouses() {
		// 	if (this.selectedId) {
		// 		this.selected = this.selectOptions.find(warehouse => warehouse._id === this.selectedId);
		// 	}
		// },
	},
};
</script>

<style lang="scss" scoped>
.option__label {
	// text-transform: capitalize;
	font-size: 16px;
	font-weight: 500;
}

.option__address {
	font-size: 12px;
	color: #797979;
}

.multiselect__option--selected {
	background: #f3f3f3;
	color: #35495e;
	font-weight: 700;

	.option__label {
		font-weight: 600 !important;
	}

	.option__address {
		font-weight: 500 !important;
	}
}
</style>
